import { combineReducers } from "redux";
import { reducer as form } from "redux-form";
import { reducer as responsive } from "redux-mediaquery";
import auth from "app/auth/reducers";
import topics from "app/topics/reducers";
import proposals from "app/proposals/reducers";
import feedback from "app/feedback/reducers";
import ratings from "app/ratings/reducers";
import comments from "app/comments/reducers";
import layout from "app/layout/reducers";
import map from "app/map/reducers";
import config from "app/config/reducers";
import { LOGOUT } from "./auth/constants";
import { intlReducer } from "react-intl-redux";

const appReducer = combineReducers({
  responsive,
  auth,
  form,
  topics,
  proposals,
  feedback,
  ratings,
  layout,
  map,
  intl: intlReducer,
  comments,
  config
});

const rootReducer = (state, action) => {
  switch (action.type) {
    case LOGOUT:
      // NOTE clear localstorage since auth incl. users is stored in there
      window.localStorage.clear();
      // NOTE be reloading all the in memory state will be gone
      // We wait 1second so the toast notification can be parsed by the user
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    default:
      return appReducer(state, action);
  }
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/app/reducers.js